import { useSelector } from '@/store'
import { useMemo } from 'react'
export function useCaptchaLanguageChange() {
  const language = useSelector((state) => state.language)
  // 语言转换
  const captchaLanguage = useMemo(() => {
    switch (language.lang) {
      case 'zh':
      case 'zh-CN':
        return 'zh-hans-cn'
      case 'zh-TW':
        return 'zh-hant-tw'
      case 'en':
        return 'en'
      case 'th':
        return 'th'
      case 'vi':
        return 'vn'
    }
  }, [language.lang])

  return captchaLanguage
}
